import React from "react";
import "./index.scss";

type FieldItemProps = {
  field: any;
  onSelectField: (id: number) => void;
};

const FieldItem = ({ field, onSelectField }: FieldItemProps) => {
  return (
    <div
      className="field-item__container normal-button"
      onClick={() => onSelectField(field.id)}
      style={{ opacity: field.is_show ? 1 : 0.5 }}
    >
      <span className="field-name">{field.name}</span>
    </div>
  );
};

export default FieldItem;
